// /src/components/tiptap/bubbleMenu/handleBubbleAction.ts

import { streamGeneration } from "@/hooks/generate/streamGeneration"

export async function handleBubbleAction(
    action:
      | "summarize"
      | "translate"
      | "enrich"
      | "checkGrammar"
      | "generateQuestions",
    selectedText: string,
    editor: any, // Optionally use `Editor` type from @tiptap/react
    langCode?: string,
  ) {
    if (!selectedText || selectedText.trim() === "") {
      console.warn("No text selected")
      return
    }
  
    switch (action) {
      case "summarize":
        console.log("🧠 Summarizing:", selectedText)
        await streamGeneration("summarize", selectedText, editor)
        break
      case "enrich":
          console.log("🔧 enrich:", selectedText)
          await streamGeneration("enrich", selectedText, editor)
          break
      case "checkGrammar":
        console.log("🔧 checkGrammar:", selectedText)
        await streamGeneration("checkGrammar", selectedText, editor)
        break
      case "translate":
        console.log("🌐 Translating:", selectedText, langCode)
        await streamGeneration("translate", selectedText, editor, langCode)
        break
      case "generateQuestions":
        console.log("❓ Generating questions from:", selectedText)
        break
      default:
        console.warn("Unknown bubble menu action:", action)
    }
  
    // Optional: Use `editor.commands.insertContent(...)` if needed
  }
  